import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
interface LayoutProps {
  onLogout: () => void;
}
const Layout: React.FC<LayoutProps> = ({
  onLogout
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-71">
      {/* Desktop sidebar */}
      <div className="hidden md:flex md:w-64 md:flex-col" data-id="element-72">
        <div className="flex flex-col flex-grow shadow-sm border-r border-gray-100" data-id="element-73">
          <Sidebar onLogout={onLogout} data-id="element-74" />
        </div>
      </div>
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden transition-opacity duration-300 ${sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-75">
        {/* Overlay */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={toggleSidebar} data-id="element-76" />
        {/* Sidebar panel */}
        <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white" data-id="element-77">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-78">
            <button onClick={toggleSidebar} className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" data-id="element-79">
              <span className="sr-only" data-id="element-80">Close sidebar</span>
              <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" data-id="element-81">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-82" />
              </svg>
            </button>
          </div>
          <Sidebar onLogout={onLogout} data-id="element-83" />
        </div>
      </div>
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-84">
        <Header toggleSidebar={toggleSidebar} onLogout={onLogout} data-id="element-85" />
        <main className="flex-1 overflow-y-auto bg-gray-50" data-id="element-86">
          <div className="py-3" data-id="element-87">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-88">
              <Outlet data-id="element-89" />
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default Layout;